import api from "./api";

/**
 * Create a new warehouse.
 *
 * POST /api/warehouse
 *
 * payload:
 * {
 *   name: string,
 *   addressId: number | null,
 *   managerId: number | null,
 *   capacity: number
 * }
 */
export const createWarehouse = async (payload) => {
    const request = {
        name: payload.name?.trim() || "",
        addressId:
            payload.addressId === "" ||
                payload.addressId === undefined ||
                payload.addressId === null
                ? null
                : Number(payload.addressId),
        managerId:
            payload.managerId === "" ||
                payload.managerId === undefined ||
                payload.managerId === null
                ? null
                : Number(payload.managerId),
        capacity: Number(payload.capacity),
    };

    const response = await api.post("/warehouse", request);
    return response.data;
};

/**
 * �������� ������ ���� �������.
 *
 * GET /api/warehouse
 */
export const getWarehouses = async () => {
    const response = await api.get("/warehouse");
    return Array.isArray(response.data) ? response.data : [];
};

/**
 * Get warehouse by ID.
 *
 * GET /api/warehouse/{id}
 */
export const getWarehouseById = async (id) => {
    const warehouseId = Number(id);

    if (!Number.isInteger(warehouseId) || warehouseId <= 0) {
        throw new Error("Warehouse ID must be a positive integer.");
    }

    const response = await api.get(`/warehouse/${warehouseId}`);
    return response.data;
};

/**
 * Add a warehouse operation.
 *
 * POST /api/warehouse/{warehouseId}/operation
 *
 * payload:
 * {
 *   shipmentId: number | null,
 *   parcelId: number | null,
 *   operationType: string,
 *   notes: string | null
 * }
 */
export const addWarehouseOperation = async (
    warehouseId,
    payload
) => {
    const id = Number(warehouseId);

    if (!Number.isInteger(id) || id <= 0) {
        throw new Error("Warehouse ID must be a positive integer.");
    }

    const request = {
        shipmentId:
            payload.shipmentId === "" ||
                payload.shipmentId === undefined ||
                payload.shipmentId === null
                ? null
                : Number(payload.shipmentId),
        parcelId:
            payload.parcelId === "" ||
                payload.parcelId === undefined ||
                payload.parcelId === null
                ? null
                : Number(payload.parcelId),
        operationType: payload.operationType?.trim() || "",
        notes: payload.notes?.trim() || null,
    };

    const response = await api.post(
        `/warehouse/${id}/operation`,
        request
    );

    return response.data;
};

/**
 * Obtain a warehouse transaction log.
 *
 * GET /api/warehouse/{warehouseId}/operations
 */
export const getWarehouseOperations = async (warehouseId) => {
    const id = Number(warehouseId);

    if (!Number.isInteger(id) || id <= 0) {
        throw new Error("Warehouse ID must be a positive integer.");
    }

    const response = await api.get(
        `/warehouse/${id}/operations`
    );

    return Array.isArray(response.data) ? response.data : [];
};

const warehouseService = {
    createWarehouse,
    getWarehouses,
    getWarehouseById,
    addWarehouseOperation,
    getWarehouseOperations,
};

export default warehouseService;